import { ROLES } from 'config/constants';

// TODO: update messages when they appeared
export const getDeclineDescription = (userRole) => {
  switch (userRole) {
    case ROLES.SPONSOR:
      return 'You can leave a note for this Organization and let them know why you are declining with them.';
    case ROLES.RESEARCH_SITE:
      return 'You can leave a note for this Organization and let them know why you are declining with them.';
    default:
      return '';
  }
};
